import React from "react";
import { useParams } from "react-router-dom";
import { ProfileCard } from "../../../../components/cards/ProfileCardApplicant";
import Language from "./Language";
import { Sidebar } from "../Sidebar";
import ProfileTabs from "../ProfileTabs";
import SocialMedia from "../../../applicant/Onboarding/BasicInformation/SocialMedia";
import PresentAddress from "../../../applicant/Onboarding/BasicInformation/PresentAddress";
import PermanentAddress from "../../../applicant/Onboarding/BasicInformation/PermanentAddress";
import PersonalInformation from "./PersonalInformation";

export default function BasicInformation() {
  const { id } = useParams();

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mt-5">
          <div className="main_contents_div">
            <ProfileCard id={id} />
            <ProfileTabs id={id} />
            <PersonalInformation id={id} />
            {id && <SocialMedia id={id} />}
            {id && <Language id={id} />}
            {id && <PresentAddress id={id} />}
            {id && <PermanentAddress id={id} />}
          </div>
        </div>
      </div>
    </div>
  );
}
